var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cockpit-line-item",class:{
    selected: _vm.selected
  },on:{"click":function($event){return _vm.$emit('select', _vm.line.lineId)}}},[_vm._v(" "+_vm._s(_vm.line.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }